import styled from 'styled-components'

export const Chevron = styled.img`
  transform: ${({ menuIsOpen }) => (menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.25s;
  will-change: transition;
  color: ${({ theme }) => theme.colors.green};
`
